export default "/images/participants_background.webp"